import { api } from '../../server/api';
import { syncClock } from './utils/clock';
import { AttendanceResponse, Challenge, QrResponse, QrType } from './types';

/** Reads `body` (ApiResponse) and syncs the clock with `serverNow`. */
function unwrap<T>(response: { data: { body: T } }): T {
  const body = response.data.body as T & { serverNow?: string };
  if (body?.serverNow) syncClock(body.serverNow);
  return body;
}

export async function listChallenges(): Promise<Challenge[]> {
  const body = unwrap<{ serverNow: string; items: Challenge[] }>(
    await api.get('/events/presence')
  );
  return body.items;
}

export async function getChallenge(id: string): Promise<Challenge> {
  return unwrap(await api.get(`/events/presence/${id}`));
}

/** Generates a check-in or check-out QR. The server rejects with 409 if the state does not allow it. */
export async function requestQr(id: string, type: QrType): Promise<QrResponse> {
  return unwrap(await api.post(`/events/presence/${id}/qr`, { type }));
}

/** Light status read, used for polling while the QR is on screen. */
export async function getAttendance(id: string): Promise<AttendanceResponse> {
  return unwrap(await api.get(`/events/presence/${id}/attendance`));
}
